// stores/leadFormStore.ts
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface LeadFormData {
  leadFormHeadingHealth: string | null;
  leadFormHeadingTravel: string | null;
  leadFormHeadingCorporate: string | null;
  leadFormOfferHealth: string | null;
  leadFormOfferTravel: string | null;
  leadFormOfferCorporate: string | null;
  leadFormOfferText: string | null;
  leadFormTypes: string | null;
  isHydrated: boolean; 
}

interface LeadFormStore extends LeadFormData {
  // Actions
  setLeadFormData: (data: Partial<LeadFormData>) => void;
  resetLeadFormData: () => void;
  setHydrated: () => void;
}

const initialState: LeadFormData = {
  leadFormHeadingHealth: null,
  leadFormHeadingTravel: null,
  leadFormHeadingCorporate: null,
  leadFormOfferHealth: null,
  leadFormOfferTravel: null,
  leadFormOfferCorporate: null,
  leadFormOfferText: null,
  leadFormTypes: null,
  isHydrated: false,
};

const useLeadFormStore = create<LeadFormStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        
        // Set lead form data
        setLeadFormData: (data) =>
          set((state) => ({
            ...state,
            ...data,
          })),
        
        // Reset all lead form data
        resetLeadFormData: () => set(initialState),
        
        // Set hydrated flag
        setHydrated: () => set({ isHydrated: true }),
      }),
      {
        name: 'lead-form-storage',
        partialize: (state) => ({
          leadFormHeadingHealth: state.leadFormHeadingHealth,
          leadFormHeadingTravel: state.leadFormHeadingTravel,
          leadFormHeadingCorporate: state.leadFormHeadingCorporate,
          leadFormOfferHealth: state.leadFormOfferHealth,
          leadFormOfferTravel: state.leadFormOfferTravel,
          leadFormOfferCorporate: state.leadFormOfferCorporate,
          leadFormOfferText: state.leadFormOfferText,
          leadFormTypes: state.leadFormTypes,
        }),
        onRehydrateStorage: () => (state) => {
          state?.setHydrated();
        },
      }
    ),
    {
      name: 'lead-form-store',
    }
  )
);

export default useLeadFormStore;